<template>
    <div id="" ref="modal" class="g-modal" tabindex="-1" :class="{ event: showModal }" @keyup.esc="keyUpEvent">
        <transition name="g-modal" appear>
            <dialog v-if="showModal" open class="g-modal-dialog" :class="[...additionalModalStyle]">
                <slot name="alert"></slot>
                <header class="g-modal-header">
                    <slot name="header">
                        <h4 class="g-modal-title">{{ modalTitle }}</h4>
                    </slot>
                </header>

                <main class="g-modal-body">
                    <slot name="body">
                        {{ modalDescription }}
                    </slot>
                </main>

                <footer class="g-modal-footer">
                    <slot name="footer">{{ modalFooter }}</slot>
                </footer>
            </dialog>
        </transition>
    </div>
</template>

<script>
export default {
    name: 'GeneralModal',
    description: 'You can assign the custom options for header and body and footer.',
    props: {
        modalTitle: {
            type: String,
            default: '',
            note: 'set modal title',
        },
        modalDescription: {
            type: String,
            default: '',
            note: 'Assign description in body',
        },
        showModal: {
            type: Boolean,
            default: false,
            note: 'Show or hide modal',
        },
        modalFooter: {
            type: String,
            default: '',
        },
        additionalModalStyle: {
            type: Array,
            default: () => [],
        },
        keyUpEvent: {
            type: Function,
            default: () => {},
        },
    },
    mounted() {
        this.$refs.modal.focus();
    },
};
</script>

<style lang="scss" scoped>
.g-modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 100;
    pointer-events: none;

    &:focus {
        outline: none !important;
    }

    &-dialog {
        z-index: 102;
        margin-right: auto;
        margin-left: auto;
    }
    .alert {
        position: relative !important;
        animation: none !important;
    }

    .fade-enter-active {
        transition: opacity 0.3s ease;
    }

    .fade-leave-active {
        transition: opacity 0.3s ease;
    }

    .fade-enter,
    .fade-leave-to {
        opacity: 0;
    }

    .g-modal-enter-active {
        animation: slide-move 0.3s ease-out;
    }
    .g-modal-leave-active {
        animation: slide-move 0.3s reverse;
    }

    @keyframes slide-move {
        0% {
            -webkit-transform: translateY(-100%);
        }
        100% {
            -webkit-transform: translateY(0);
        }
    }

    .btn-block {
        margin-top: 0;
    }
    .submit-button-group {
        margin-top: -10px;
    }
}

.event {
    pointer-events: auto;
    background-color: rgba(0, 0, 0, 0.33);
}
</style>
